const loadToggler = () => {
  const toggles = Array.from(document.querySelectorAll('.slo-toggler'));

  toggles.forEach(toggle => {
    const toggleSwitches = Array.from(toggle.querySelectorAll('.slo-toggler--switch'));
    const toggleContents = Array.from(toggle.querySelectorAll('.slo-toggler--content'));

    toggleSwitches.forEach(toggleSwitch => {
      toggleSwitch.addEventListener('click', event => {
        event.preventDefault();
        toggleSwitches.forEach(_toggleSwitch => _toggleSwitch.classList.remove('active'));
        toggleSwitch.classList.add('active');

        const activeContents = Array.from(toggle.querySelectorAll('.slo-toggler--content-' + toggleSwitch.dataset.value));
        const className = event.target.dataset.toggleClass || 'hidden';
        toggleContents.forEach(toggleContent => toggleContent.classList.add(className));
        activeContents.forEach(activeContent => activeContent.classList.remove(className));
      });
    });
  });
};

export default loadToggler;
